var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08075 4.83264H18.3075C18.7559 4.83264 19.1598 5.23652 19.1598 5.68487V18.9117C19.1598 19.36 18.7559 19.7639 18.3075 19.7639H5.08075C4.63239 19.7639 4.22852 19.36 4.22852 18.9117V5.68487C4.22852 5.23652 4.63239 4.83264 5.08075 4.83264ZM14.8319 13.2165H16.8943L16.984 11.2437H14.8319V9.78677C14.8319 9.22651 14.9438 8.9123 15.6612 8.9123H16.9166L16.9618 7.07369C16.9618 7.07369 16.4015 6.98402 15.5945 6.98402C13.6217 6.98402 12.7472 8.21717 12.7472 9.54V11.2437H11.2903V13.2165H12.7472V18.6864H14.8319V13.2165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a61bf07f.svg";
export { ForwardRef as ReactComponent };